/**
 * Who an event belongs to when it is written.
 *
 * Pulled out of the IndexedDB store because it is the one decision in there that is not
 * plumbing, and the store itself cannot run under Node.
 *
 * A **new** event is stamped with the explicit owner, else the account signed in now. An
 * **existing** event keeps its owner exactly as it is — including `null`. The first version
 * wrote `existing?.writtenBy ?? current`, which stamped an unowned ball with the current user
 * the next time it was renumbered, after which it was sendable by whoever was holding the phone.
 */
export function ownerForWrite(
  existing: { readonly writtenBy?: string | null } | undefined,
  explicit: string | null | undefined,
  current: string | null,
): string | null {
  if (existing !== undefined) return existing.writtenBy ?? null;
  return explicit ?? current;
}
